import { useState } from 'react';
import type { ReportExportJob } from '@discovr/types';

function announcementFor(job: ReportExportJob): string {
  if (job.cancel_requested && job.status === 'processing') return 'Cancelling export';
  if (job.status === 'pending' || job.status === 'processing' || job.status === 'retrying') return 'Preparing report';
  if (job.status === 'done') return 'Report ready';
  if (job.status === 'failed') return 'Export failed';
  if (job.status === 'cancelled') return 'Export cancelled';
  return '';
}

function hasChanged(before: readonly ReportExportJob[], job: ReportExportJob): boolean {
  const previous = before.find((candidate) => candidate.id === job.id);
  return previous === undefined || previous.status !== job.status || previous.cancel_requested !== job.cancel_requested;
}

interface Tracked {
  jobs: readonly ReportExportJob[] | undefined;
  message: string;
}

/** Screen-reader text for the newest job whose state changed since the previous list. The first
 *  load announces nothing, so opening the page does not read out old exports. */
export function useExportAnnouncement(jobs: readonly ReportExportJob[] | undefined): string {
  const [tracked, setTracked] = useState<Tracked>({ jobs: undefined, message: '' });
  if (jobs !== undefined && jobs !== tracked.jobs) {
    const changed = tracked.jobs === undefined ? undefined : jobs.find((job) => hasChanged(tracked.jobs ?? [], job));
    setTracked({ jobs, message: changed ? announcementFor(changed) : tracked.message });
  }
  return tracked.message;
}
